import { Box, Drawer, InputBase } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import useLocalization from '../../../../hooks/useLocalization';
import useSearchAvailability from '../../../../hooks/useSearchAvailability';
import SidebarTabs from '../molecules/SidebarTabs';
import { DrawerLayoutProps } from '../../../layouts/DrawerLayout';

const GOLA_DRAWER_WIDTH = 320;
const GOLA_DRAWER_BACKGROUND_COLOR = 'neutral.800';

const styles = {
  drawer: {
    '& .MuiDrawer-paper': {
      backgroundColor: GOLA_DRAWER_BACKGROUND_COLOR,
      minWidth: GOLA_DRAWER_WIDTH,
      maxWidth: GOLA_DRAWER_WIDTH,
    },
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'neutral.800',
    borderBottom: 1,
    borderColor: 'neutral.600',
    px: 1,
    py: { xs: 0.5, md: 1 },
    cursor: 'pointer',
  },
  searchIcon: {
    color: 'neutral.500',
    mr: 0.5,
    typography: 'h2',
  },
  searchInput: {
    flex: 1,
    color: 'neutral.200',
    '& .MuiInputBase-input': {
      p: 0.5,
      typography: 'body2',
      '&::placeholder': {
        color: 'neutral.500',
        opacity: 1,
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
  },
};

const SearchHeader = () => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const { isSearchAvailable } = useSearchAvailability();

  const handleSearchClick = () => {
    navigate('/search');
  };

  if (!isSearchAvailable) return <SidebarTabs />;

  return (
    <>
      <Box sx={styles.searchBox} onClick={handleSearchClick}>
        <Search sx={styles.searchIcon} />
        <InputBase sx={styles.searchInput} placeholder={t('search')} readOnly />
      </Box>
      <SidebarTabs />
    </>
  );
};

const DrawerLayout = ({ isOpen, toggleVisibility, children }: DrawerLayoutProps) => {
  const handleClose = useCallback(() => toggleVisibility(false), [toggleVisibility]);

  return (
    <Drawer sx={styles.drawer} open={isOpen} variant='temporary' onClose={handleClose}>
      <SearchHeader />
      <Box sx={styles.content}>{children}</Box>
    </Drawer>
  );
};

export default DrawerLayout;
